<template>
  <div class="flex flex-col lg:flex-row justify-center items-center lg:items-start
    w-full h-full pt-14">
    <img src="https://baroon.fra1.digitaloceanspaces.com/dev/academy/undraw_location_search_re_ttoj.svg"
    class="w-1/2 lg:w-1/4">
    <h1 class="text-white text-lg uppercase tracking-widest flex flex-col lg:items-end
      pb-10 h-full">
      {{$t('notifications.noNotifications')}}
      <slot name="title"></slot>
    </h1>
  </div>
</template>

<script>
export default {
};
</script>
